/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  var subNavigation = $('.sub-navigation');

  /* Bind the scroll Event */
  if (subNavigation.length > 0) {
    // FIXME: turn this generic
    var subNavigationInner = subNavigation.find('.sub-navigation--inner');
    var subNavigationClone = undefined;
    var subNavigationTop = subNavigation.offset().top;
    var topMenuHeight = subNavigation.outerHeight();
    var scrollIndicatorRight = subNavigation.find('.scroll-indicator--right');
    var scrollIndicatorLeft = subNavigation.find('.scroll-indicator--left');
    var scrollTop = undefined;
    var $window = $(window);
    var menuItems = subNavigation.find('.sub-navigation--link').find('a');  // The nav links
    var maxWidth = 500;
    var lastKnownScrollId = null;
    var scrollHorizontalDebounceTimeout = null;
    var scrollDebounceTimeout = null;
    var memberReviewsLink = $('.js-member-reviews-scroll');

    var hasHorizontalScroll = function hasHorizontalScroll() {
      return subNavigationInner.prop('scrollWidth') > subNavigationInner.width();
    };

    var initialiseHorizontalScroll = function initialiseHorizontalScroll() {
      if (hasHorizontalScroll()) {
        scrollIndicatorRight.removeClass('disabled');
      }

      scrollIndicatorRight.disableSelection();
      return scrollIndicatorLeft.disableSelection();
    };

    initialiseHorizontalScroll();

    // Returns an array of section anchors
    var findScrollItems = function findScrollItems(menuItems) {
      return menuItems.map(function() {
        var item = getLinkedItem(this);
        if (item.length) {
          return item;
        }
      });
    };

    // Determine which of the page's sections we've scrolled to
    var getIdOfCurrentScrollSection = function getIdOfCurrentScrollSection(menuItems, fromTop) {
      var cur = (findScrollItems(menuItems)).map(function() {
        if ($(this).offset().top < fromTop) { return this; }
      });
      cur = cur[cur.length-1];
      if (cur && cur.length) { return cur[0].id; } else { return ''; }
    };

    var setActiveMenuItem = function setActiveMenuItem(menuItems, activeItemId) {
      var newActiveItem = menuItems.filter('[href=\\#' + activeItemId + ']').parent();
      menuItems.parent().removeClass('is-active'); // clear all classes
      newActiveItem.addClass('is-active');
      return subNavigationInner.animate({scrollLeft: newActiveItem.position().left}, 300);
    };

    // Returns a clone of the header, already inserted into the DOM
    var cloneSubNavigationHeader = function cloneSubNavigationHeader(subNavigationHeader) {
      return subNavigationHeader
        .clone()
        .prop('id', subNavigationHeader.prop('id') + '-clone')
        .css('visibility', 'hidden')
        .insertBefore(subNavigationHeader);
    };

    var getLinkedItem = function getLinkedItem(menuItem) {
      return $($(menuItem).attr('href'));
    };

    var setActiveMenuItemOnScroll = function setActiveMenuItemOnScroll() {
      scrollTop = $window.scrollTop();
      if (scrollTop >= subNavigationTop) {
        if (!subNavigationClone) {

          /* Attach a clone to replace the "missing" body height */
          subNavigationClone = cloneSubNavigationHeader(subNavigation);
          subNavigation.addClass('is-fixed');
        }

        // Activate nav items as we scroll into their respective sections
        var fromTop = scrollTop + topMenuHeight;
        var id = getIdOfCurrentScrollSection(menuItems, fromTop);
        if (id && (lastKnownScrollId !== id)) {
          lastKnownScrollId = id;
          setActiveMenuItem(menuItems, id);
        }

      } else if ((scrollTop < subNavigationTop) && subNavigationClone) {

        /* Since subNavigation is in the viewport again, we can remove the clone and the class */

        subNavigationClone.remove();
        subNavigationClone = null;
        subNavigation.removeClass('is-fixed');
      }
    };

    var setScrollIndicatorStatesOnScroll = function setScrollIndicatorStatesOnScroll() {
      if (hasHorizontalScroll()) {
        // The scroll is at the beggining?
        if (subNavigationInner.scrollLeft() === 0) {
          scrollIndicatorLeft.addClass('disabled');
        } else {
          scrollIndicatorLeft.removeClass('disabled');
        }

        // The scroll is at the end?
        if ((subNavigationInner.scrollLeft() + subNavigationInner.width()+5) >= subNavigationInner[0].scrollWidth) {
          return scrollIndicatorRight.addClass('disabled');
        } else {
          return scrollIndicatorRight.removeClass('disabled');
        }

      } else {
        scrollIndicatorLeft.addClass('disabled');
        return scrollIndicatorRight.addClass('disabled');
      }
    };

    memberReviewsLink.click(function(e) {
      // Animated scroll to member ratings section
      var offsetTop = (getLinkedItem(this).offset().top - topMenuHeight) + 1;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
      return e.preventDefault();
    });

    menuItems.click(function(e) {
      // Animated scroll to the correct section
      var offsetTop = (getLinkedItem(this).offset().top - topMenuHeight) + 1;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
      return e.preventDefault();
    });

    scrollIndicatorRight.on('click', function(e) {
      return subNavigationInner.animate({scrollLeft: '+=74'}, 100, function() {});
    });

    scrollIndicatorLeft.on('click', function(e) {
      return subNavigationInner.animate({scrollLeft: '-=75'}, 100, function() {});
    });

    subNavigationInner.on('scroll', function(e) {
      clearTimeout(scrollHorizontalDebounceTimeout);
      return scrollHorizontalDebounceTimeout = setTimeout(setScrollIndicatorStatesOnScroll, 100);
    });

    $window.on('scroll', function(e) {
      clearTimeout(scrollDebounceTimeout);
      return scrollDebounceTimeout = setTimeout(setActiveMenuItemOnScroll, 100);
    });

    $window.on('resize', function(e) {
      return initialiseHorizontalScroll();
    });

    return $('.js-product-test-button').on('click', function(e) {
      e.preventDefault();
      $(this).css('outline', 'none');
      var offsetTop = ($('#how-we-test').offset().top - topMenuHeight) + 1;
      return $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
    });
  }
});
